import type {
  ThemeOptions,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants
} from '@mui/material/styles';

import { type Theme } from '../ThemeRegistry/theme.types';

const defaultProps: ComponentsProps['Accordion'] = {};

const styleOverrides: ComponentsOverrides<Theme>['Accordion'] = {
  root: ({ theme, ownerState }) => ({
    containerType: 'inline-size',
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'var(--grid-gap-lg)'
  }),

  introTextGrid: {
    '[class*=Section-itemsGrid] &': {
      display: 'contents !important'
    },
    
    '[class*=Grid-root]': {
      gridColumn: 'full-start/full-end'
    }
  },

  contentOuterGrid: ({ theme }) => ({
    '> *': {
      gridColumnStart: 'start',
      gridColumnEnd: 'end'
    },
    'rowGap': 0,

    '& [class*="MuiAccordionSummary-content"]': {
      justifyContent: 'space-between'
    },

    '& [class*="Mui-expanded"]': {
      margin: 0,
      minHeight: 'unset'
    },

    '& [class*="Accordion-detailsWrap"]': {
      padding: theme.spacing(2, 3),

      div: {
        background: 'inherit'
      }
    }
  }),

  accordionItem: {
    'boxShadow': 'none',

    '&::before': {
      position: 'unset'
    }
  },

  arrowIcon: ({ open }) => ({
    transition: 'transform 300ms ease-in-out',
    transform: open ? 'rotate(-180deg)' : 'rotate(0deg)',
    display: 'flex',
    alignItems: 'center'
  }),

  summary: ({ theme, ownerState }) => ({
    ...theme.typography.body1,
    margin: 0
  }),

  summaryWrap: ({ theme, ownerState }) => ({
    'padding': theme.spacing(2, 3),
    'minHeight': 'unset',
    'borderBottom': '2px solid var(--mui-palette-divider)',

    ...(!!ownerState?.isFirst && {
      borderTop: '2px solid var(--mui-palette-divider)'
    }),

    '& [class*="MuiAccordionSummary-contentGutters"]': {
      margin: 0
    }
  }),

  actionsWrap: ({ theme, ownerState }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'var(--grid-gap-xxl)',
    gap: theme.spacing(4),

    [theme.containerBreakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: 'var(--grid-gap)',
      justifyContent: 'center',
      marginTop: 'var(--grid-margin-lg)'
    }
  })
};

const createVariants = (_theme: Theme): ComponentsVariants['Accordion'] => [];

export const AccordionTheme = (theme: Theme): ThemeOptions => ({
  components: {
    Accordion: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});

export default AccordionTheme;
